import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import RegionTable from '../components/RegionTable';

const RegionList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">Regions</span>
      </Portal>
      {pageSize && <RegionTable />}
    </Card>
  );
};

export default RegionList;
